/**
 * Authenticated fetch for Shopify embedded apps.
 *
 * Uses App Bridge v4's `shopify.idToken()` to get a session token
 * and includes it as a Bearer token in the Authorization header.
 *
 * In embedded mode, the app runs inside Shopify's admin iframe,
 * so relative URLs would resolve against admin.shopify.com.
 * We need to use the app's actual backend URL as the base.
 */

const APP_API_BASE = process.env.REACT_APP_API_URL || '';

export async function authenticatedFetch(url, options = {}) {
  const token = await window.shopify.idToken();

  const headers = {
    ...options.headers,
    Authorization: `Bearer ${token}`,
  };

  // If url starts with /, prepend the app's API base URL
  const fullUrl = url.startsWith('/') && APP_API_BASE ? `${APP_API_BASE}${url}` : url;

  return fetch(fullUrl, { ...options, headers });
}
